module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProHeavy.efedd35.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProHeavy.woff2
// module id = v23i
// module chunks = 1